import React, {useEffect, useState} from 'react';
import {ArrowLeftOutlined} from "@ant-design/icons";
import {NavBar} from "antd-mobile";
import {getNavBarContainerStyle} from "../../../utils/deviceUtils";
import {useNavigate} from "react-router-dom";
import {DspPath, TaskPath} from "../../../enums/DeliveryNavigatePathEnum";
import {OrderBaseItem} from "../task/components/TrackingTablePage";
import {TrackingTableTitle} from "../../../enums/DeliveryTrackingTableEnum";
import {t} from "../../../i18n";


interface  MulticolumnTrackingTableProps {
    title: string;
    tableRows: String[];
    data: OrderBaseItem[];
}

const MulticolumnTrackingTablePage: React.FC<MulticolumnTrackingTableProps> = ({title, tableRows, data}) => {
    const navigate = useNavigate();
    const [path, setPath] = useState<string>(TaskPath.DELIVERY_TASK_ASSIGNMENTS);
    const [head, setHead] = useState<string>(t('pages.details'));

    useEffect(() => {
        if (title === TrackingTableTitle.ARRIVAL_SCAN_DETAILS){
            setPath(DspPath.DELIVERY_DSP_RECEIVING_SORTING_SCAN);
        }
    }, [title]);

    return (
        <div className="max-w-md mx-auto bg-white overflow-hidden">
            <div className="fixed top-0 left-0 right-0 z-10 bg-white">
                <div {...getNavBarContainerStyle('pb-1')}>
                    <NavBar
                        onBack={() => navigate(path)}
                        backIcon={<ArrowLeftOutlined/>}
                    >
                        {head}
                    </NavBar>
                </div>
                <div className="p-1">
                    <div className="grid grid-cols-12 mb-1 font-medium text-gray-500 border-b-2">
                        <div className="col-span-7 px-1">{tableRows[0]}</div>
                        <div className="col-span-2 px-1">{tableRows[1]}</div>
                        <div className="col-span-3 px-1">{tableRows[2]}</div>
                    </div>
                </div>
            </div>
            <div className="mt-20">
                {data.length > 0 && (
                    <div className="p-4">
                        {data.map((item, index) => (
                            <div key={index} className="grid grid-cols-12 py-3 border-b border-gray-100">
                                <div className="col-span-7 px-1 font-mono text-sm">
                                    {item.trackingNumber}
                                </div>
                                <div className="col-span-2 px-1 font-mono text-sm">
                                    {item.stop}
                                </div>
                                <div className="col-span-3 px-1 font-mono text-sm">
                                    {item.value}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default MulticolumnTrackingTablePage;